module.exports = __webpack_public_path__ + "static/media/P1_word.2247c689.png";